var map = {
	"./geojson.json": 96,
	"./table-schema.json": 180,
	"./topojson.json": 97
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 333;


//////////////////
// WEBPACK FOOTER
// ./~/tableschema/lib/profiles ^\.\/.*\.json$
// module id = 333
// module chunks = 0